// extracted by mini-css-extract-plugin
export default {"home_container":"Home_home_container__1eV0a","home_title":"Home_home_title__DAcW9"};